import React, { useState, useEffect } from 'react';
import { Button, Alert } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useCanvaEmbedDocument } from '../hooks/useCanvaEmbedDocument.ts';

interface PurchaseData {
  productName?: string;
  productId?: string;
  value: number;
  currency?: string;
}

const CanvaBack = () => {
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);

  useCanvaEmbedDocument();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const errorParam = queryParams.get('error');
    const sessionId = queryParams.get('session_id');
    const success = queryParams.get('success');

    if (errorParam === '12') {
      setError('Your session has expired. Please go back to Canva and restart.');
    } else {
      setError(null);
    }

    if ((sessionId || success === 'true') && typeof window !== 'undefined' && (window as any).fbq) {
      let purchaseData: PurchaseData | null = null;
      if (window.localStorage) {
        const storedData = window.localStorage.getItem('pendingPurchase');
        if (storedData) {
          try {
            purchaseData = JSON.parse(storedData) as PurchaseData;
            window.localStorage.removeItem('pendingPurchase');
          } catch (e) {
            console.error('Failed to parse purchase data from localStorage', e);
          }
        }
      }

      const purchaseParams: Record<string, unknown> = {
        content_name: purchaseData?.productName || 'Subscription Purchase',
        content_category: 'Purchase',
      };

      if (purchaseData && purchaseData.value !== undefined && purchaseData.value > 0) {
        purchaseParams.value = purchaseData.value;
        purchaseParams.currency = purchaseData.currency || 'USD';
      }

      if (purchaseData?.productId) {
        purchaseParams.content_ids = [purchaseData.productId];
      }

      (window as any).fbq('track', 'Purchase', purchaseParams);
    }
  }, [location.search]);

  return (
    <>
      <Helmet>
        <title>AI Music</title>
      </Helmet>

      <div className="canva-purchase-page">
        <main className="canva-purchase-main">
          <div className="container-wide px-3 px-md-4 px-lg-4 pb-5">
            <div className="canva-embed-simple-inner mx-auto" style={{ maxWidth: '28rem' }}>
              <h1 className="canva-purchase-title text-center mb-4 px-2">
                <span className="canva-purchase-title-accent">Muzaic</span>
              </h1>
              <div className="canva-back-card rounded-4 border p-4 p-md-5">
                {error ? (
                  <Alert variant="danger" className="canva-back-alert mb-4">
                    {error}
                  </Alert>
                ) : null}
                <div className="d-grid">
                  <Button
                    onClick={() => window.close()}
                    variant="primary"
                    className="rounded-4 py-3 fw-semibold"
                  >
                    Back to Canva
                  </Button>
                </div>
              </div>
            </div>
            <footer className="canva-purchase-footer text-center pt-4 pb-3 px-3">
              © Muzaic {new Date().getFullYear()}
            </footer>
          </div>
        </main>
      </div>
    </>
  );
};

export default CanvaBack;
